export async function getLeftMenuData() {
  // 左選單
  return []
}
export async function getTopMenuData() {
  // 上選單
  return []
}
